(function () {
  var root = document.documentElement;
  if (!root.classList.contains('gc-site')) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var boot = document.querySelector('[data-gc-boot]');

  function finishBoot() {
    if (boot) boot.classList.add('is-done');
    root.classList.remove('is-loading');
    root.classList.add('is-loaded');
    try {
      sessionStorage.setItem('gc-boot-done', '1');
    } catch (e) {}
  }

  if (boot && !reduced && !(window.Shopify && window.Shopify.designMode)) {
    try {
      if (sessionStorage.getItem('gc-boot-done') === '1') {
        finishBoot();
        return;
      }
    } catch (e) {}

    var log = boot.querySelector('[data-gc-boot-log]');
    var fill = boot.querySelector('[data-gc-boot-fill]');
    var lines = [
      { text: '> loading gulag_creations...', cls: '' },
      { text: '> storefront_assets: OK', cls: '' },
      { text: '> community_hub: connected', cls: 'gc-boot__line--gold' },
      { text: '> welcome, survivor.', cls: 'gc-boot__line--gold' }
    ];
    var step = 0;

    function addLine() {
      if (!log || step >= lines.length) {
        if (fill) fill.style.width = '100%';
        setTimeout(finishBoot, 120);
        return;
      }
      var item = lines[step];
      var el = document.createElement('span');
      el.className = 'gc-boot__line' + (item.cls ? ' ' + item.cls : '');
      el.textContent = item.text;
      log.appendChild(el);
      if (fill) fill.style.width = Math.round(((step + 1) / lines.length) * 100) + '%';
      step += 1;
      setTimeout(addLine, step === 1 ? 60 : 90);
    }

    setTimeout(addLine, 40);
  } else {
    finishBoot();
  }
})();
